import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AngularFireAuthModule} from '@angular/fire/auth';

import { LoginComponent } from './login/login.component';
import { RouterModule, Routes } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import * as fromAuth from './reducers';
import { AuthGuard } from './auth.guard';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './auth.effects';


const routes: Routes = [
  { path: 'user',
    children: [
      { path: 'login', component: LoginComponent},
      
    ] }
]


@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    AngularFireAuthModule,
    RouterModule.forChild(routes),
    // StoreModule.forFeature(fromAuth.authFeatureKey, fromAuth.reducers, { metaReducers: fromAuth.metaReducers }) // au remove
    StoreModule.forFeature(fromAuth.authFeatureKey, fromAuth.authReducer),
    EffectsModule.forFeature([AuthEffects])
  ],
  providers: [
    AuthGuard
  ]
})
export class AuthModule { }
